// @ts-nocheck
import wPhotoPropertiesPlugin from './plugins/wPhotoPropertiesPlugin';
import vectorImagePropertiesPlugin from './plugins/vectorImagePropertiesPlugin';

export {
  wPhotoPropertiesPlugin as WPhotoProperties,
  vectorImagePropertiesPlugin as VectorImageProperties,
};
